<template>
  <div class="menu-toggle">
    <button
      class="menu-toggle__button"
      :class="[{'menu-toggle__button--is-open': isOpen}]"
      @click="toggle">
      <span class="menu-toggle__icon" :class="[{'menu-toggle__icon--is-open': isOpen}]">
        <span class="menu-toggle__icon__line menu-toggle__icon__line--1"></span>
        <span class="menu-toggle__icon__line menu-toggle__icon__line--2"></span>
        <span class="menu-toggle__icon__line menu-toggle__icon__line--3"></span>
      </span>
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMenuToggle',
  methods: {
    toggle: function () {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
    open () {
      this.$store.dispatch('ui/open', {
        action: 'menu/open',
        stopScroll: true
      })
    },
    close () {
      this.$store.dispatch('ui/close', { action: 'menu/close' })
    }
  },
  computed: {
    ...mapGetters({
      isOpen: 'menu/isOpen'
    })
  }
}
</script>

<style lang="scss" scoped>
  @import './menu-toggle'
</style>



// WEBPACK FOOTER //
// src/components/AppMenuToggle/AppMenuToggle.vue